/**
 * Duration (ms) that the channel completion banner should persist
 * after the first round in double-vote mode before clearing.
 * Fixed to 60s to keep UX predictable regardless of channel settings.
 */
export const DOUBLE_VOTE_CLEAR_MS = 60_000;
